<mat-slide-toggle
  color="primary"
  [disableControl]="disabled"
  [checked]="checkedFlag"
  [formControl]="formControl"
  (change)="onEnableChangetoggle($event)">
</mat-slide-toggle>
